import { createSlice } from '@reduxjs/toolkit';

export interface IHomeFilter {
  globalFilters: Array<any>;
  filters: Object;
  filtersSelectionOrder: Array<any>;
}

const initialState: IHomeFilter = {
  globalFilters: [],
  filters: {},
  filtersSelectionOrder: [],
};

export const homeFilters = createSlice({
  name: 'homeFilter',
  initialState,
  reducers: {
    setGlobalFilters: (state, action) => {
      state.globalFilters = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setFiltersSelectionOrder: (state, action) => {
      state.filtersSelectionOrder = action.payload;
    },
  },
});
export const { setGlobalFilters, setFilters, setFiltersSelectionOrder } =
  homeFilters.actions;
export default homeFilters.reducer;
